import "core-js/modules/es.array.index-of";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.trim";

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}
/**
   * @param {string} str
   * @returns {Boolean}
   */

export function validUsername(str) {
  var valid_map = ['admin', 'editor'];
  return valid_map.indexOf(str.trim()) >= 0;
}
/**
   * @param {string} url
   * @returns {Boolean}
   */

export function validURL(url) {
  var reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
  return reg.test(url);
}
/**
   * @param {string} str
   * @returns {Boolean}
   */

export function validLowerCase(str) {
  var reg = /^[a-z]+$/;
  return reg.test(str);
}
/**
   * @param {string} str
   * @returns {Boolean}
   */

export function validUpperCase(str) {
  var reg = /^[A-Z]+$/;
  return reg.test(str);
}
/**
   * @param {string} str
   * @returns {Boolean}
   */

export function validAlphabets(str) {
  var reg = /^[A-Za-z]+$/;
  return reg.test(str);
}
/**
   * @param {string} email
   * @returns {Boolean}
   */

export function validEmail(email) {
  var reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return reg.test(email);
}
/**
   * @param {string} str
   * @returns {Boolean}
   */

export function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true;
  }

  return false;
}
/**
   * @param {Array} arg
   * @returns {Boolean}
   */

export function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]';
  }

  return Array.isArray(arg);
}
/**
 * @function 处理金额2位小数
 * @param {string} str
 * @returns {String}
 */

export function isAmount(str, max) {
  str = str.replace(/^(\d+)\.(\d\d).*$/, '$1.$2'); // 如果没有小数点，不能为类似 01、02的金额

  if (str !== '' && Number(str) <= max) {
    return Number(parseFloat(str)).toFixed(2);
  }

  if (str !== '' && Number(str) > max) {
    return Number(parseFloat(max)).toFixed(2);
  } // 如果有小数点，不能为类似 1.10的金额
  // if (str.indexOf('.') > 0 && str.indexOf('0') > 2) {
  //   return parseFloat(str)
  // }
  // 如果有小数点，不能为类似 0.00的金额
  // if (str.indexOf('.') > 0 && str.lastIndexOf('0') > 2) {
  //   return parseFloat(str)
  // }


  return Number(str).toFixed(2);
}
/**
 * @function 数字不能超过最大值
 * @param {string,number} str
 * @returns {number}
 */

export function maxNum(num, max) {
  if (num !== '' && Number(num) > max) {
    return Number(parseFloat(max));
  }

  return Number(num);
}
/**
 *
 * @function 校验输入框中是否包含特殊字符
 * @param str 文本框内容
 *
 */

export function checkSpecialStr(str) {
  // 规则对象(flag)
  var flag = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？ ]"); // 判断 even 是否包含特殊字符

  if (flag.test(str)) {
    // 包含特殊字符
    return true;
  } else {
    // 不包含特殊字符
    return false;
  }
}
/**
 * @function 校验输入框中手机号是否符合规则
 * @param str 输入框内容
 */

export function checkPhone(str) {
  var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;

  if (!myreg.test(str)) {
    // 手机号格式不正确
    return false;
  } else {
    return true;
  }
}